import PropTypes from 'prop-types'
import React from 'react'
import { Field, Form, FormSpy } from 'react-final-form'
import axios from 'axios'

import TextFieldRounded from 'components/_form/TextFieldRounded'
import {
  composeValidators,
  errorCustom,
  errorFromDict,
  isEmail,
  required,
} from 'forms/validations'
import { subscribeHealthyEating } from 'utils/api'
import { gtmEvent } from 'utils/client/analitics'
import { Button } from 'shared/Button'

import { FormBox, FieldBox } from './styles'

const SUBSCRIBE_FORM = 'subscribe_email'

const SubscribeEmailForm = ({
  errorsDict,
  texts,
  countryCode,
  onSubmited,
  isMobile,
  isSucceed,
  setIsSucceed,
}) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [isInvalid, setIsInvalid] = React.useState(false)
  const isSubmitted = isSucceed || isLoading

  const handleSubmit = React.useCallback(
    ({ email }) => {
      if (isLoading) {
        return
      }

      setIsLoading(true)

      subscribeHealthyEating({ email, country: countryCode })
        .then(resp => {
          if (
            typeof resp === 'object' &&
            'subscribed' in resp &&
            resp.subscribed === true
          ) {
            setIsLoading(false)
            setIsSucceed(true)

            gtmEvent({
              event: 'Block Email Subscribe — Leave Email — Success',
            })

            axios
              .post(`/bff?email=${email}`)
              .catch(error => {
                console.error(error)
              })

            onSubmited && onSubmited()
          } else {
            setIsLoading(false)
            setIsSucceed(false)
            gtmEvent({
              event: 'Block Email Subscribe — Leave Email — Error',
              description: resp.error,
            })
          }
        })
        .catch(err => {
          setIsLoading(false)
          setIsSucceed(false)
          gtmEvent({
            event: 'Block Email Subscribe — Leave Email — Error',
            description: JSON.stringify(err?.response),
          })
        })
    },
    [isLoading, countryCode, onSubmited],
  )

  const handleRemoteSubmit = React.useCallback(() => {
    document
      .getElementById(SUBSCRIBE_FORM)
      .dispatchEvent(new Event('submit', { cancelable: true }))

    return !isInvalid
  }, [isInvalid])

  return (
    <FormBox isInvalid={isInvalid}>
      <FieldBox isInvalid={isInvalid}>
        <Form
          onSubmit={handleSubmit}
          render={({ submitting, handleSubmit }) => (
            <form id={SUBSCRIBE_FORM} onSubmit={handleSubmit}>
              <TextFieldRounded
                autoComplete='off'
                placeholder={texts.placeholder}
                name='email'
                isDisabled={isSubmitted}
                validate={composeValidators([
                  errorCustom(errorsDict.email_required, required),
                  errorFromDict(errorsDict, isEmail),
                ])}
              />

              <Field
                name='submit'
                type='submit'
                component='input'
                hidden={true}
                disabled={submitting}
              />

              <FormSpy
                subscription={{
                  invalid: true,
                  touched: true,
                }}
                onChange={({ invalid, touched }) => {
                  if (touched.email) {
                    setIsInvalid(invalid)
                  }
                }}
              />
            </form>
          )}
        />
      </FieldBox>

      <Button
        onClick={handleRemoteSubmit}
        loading={isLoading ? isLoading : undefined}
        block={isMobile}
      >
        {texts.button}
      </Button>
    </FormBox>
  )
}

SubscribeEmailForm.propTypes = {
  isSucceed: PropTypes.bool.isRequired,
  setIsSucceed: PropTypes.func.isRequired,
  texts: PropTypes.object.isRequired,
  errorsDict: PropTypes.object.isRequired,
  countryCode: PropTypes.string.isRequired,
  onSubmited: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
}

export default React.memo(SubscribeEmailForm)
